import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconLogoWiggotWhite from '../build/icon-logo-wiggot-white'

export const IconLogoWiggotWhiteComponent: React.FC<Omit<SvgProps, 'src'>> = (
  props
) => {
  return <Svg {...props} src={iconLogoWiggotWhite} />
}

export default IconLogoWiggotWhiteComponent
